import { Box, Text } from '@chakra-ui/react';
import {
	Bar,
	BarChart,
	CartesianGrid,
	LabelList,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from 'recharts';

const CustomTooltip = ({ active, payload }) => {
	if (active && payload?.length > 0) {
		const { nombreCompleto, total } = payload[0].payload;
		return (
			<Box
				bg='white'
				p={3}
				border='1px solid #ccc'
				rounded='md'
				shadow='md'
			>
				<Text fontWeight='bold'>{nombreCompleto}</Text>
				<Text color='green.600'>total : {total}</Text>
			</Box>
		);
	}
	return null;
};

const ActividadesResponsable = ({ data, altoGrafico }) => (
	<Box overflowX='auto'>
		<Box minW='700px'>
			<ResponsiveContainer width='100%' height={altoGrafico}>
				<BarChart
					layout='vertical'
					data={data}
					margin={{
						top: 20,
						right: 60,
						left: 20,
						bottom: 20,
					}}
				>
					<CartesianGrid strokeDasharray='3 3' />
					<XAxis type='number' />
					<YAxis
						dataKey='nombre'
						type='category'
						interval={0}
						width={160}
					/>
					<Tooltip content={<CustomTooltip />} />
					<Bar dataKey='total' fill='#2F855A'>
						<LabelList
							dataKey='total'
							position='right'
							formatter={value => (value > 0 ? value : '')}
						/>
					</Bar>
				</BarChart>
			</ResponsiveContainer>
		</Box>
	</Box>
);

export default ActividadesResponsable;
